import {
  lazy,
  memo,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useState,
} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Loading from '../components/layouts/Loading';
import { CartContext } from '../contexts/CartContext';
import { getCategories } from '../redux/actions/categories';
import {
  getLatestProducts,
  getProducts,
  getTopDiscountProducts,
} from '../redux/actions/products';
import { categories$, products$, toast$ } from '../redux/selectors';

const Tooltip = lazy(() => import('../components/layouts/Tooltip'));
const Discount = lazy(() => import('../components/products/Discount'));
const Header = lazy(() => import('../components/products/Header'));
const LatestProducts = lazy(() =>
  import('../components/products/LatestProducts')
);
const ListCategories = lazy(() =>
  import('../components/products/ListCategories')
);
const ListProducts = lazy(() => import('../components/products/ListProducts'));
const PriceRangeSlider = lazy(() =>
  import('../components/products/PriceRangeSlider')
);

const Products = () => {
  const dispatch = useDispatch();
  const categories = useSelector(categories$);
  const products = useSelector(products$);
  const { addCart } = useContext(CartContext);
  const toast = useSelector(toast$);
  const [minValue, setMinValue] = useState(0);
  const [maxValue, setMaxValue] = useState(2500000);

  useEffect(() => {
    if (categories.data.length === 0) {
      dispatch(getCategories.getCategoriesRequest());
    }
    if (products.latestProducts.length === 0) {
      dispatch(getLatestProducts.getLatestProductsRequest());
    }
    if (products.topDiscountProducts.length === 0) {
      dispatch(getTopDiscountProducts.getTopDiscountProductsRequest());
    }
    if (products.data.length === 0) {
      dispatch(getProducts.getProductsRequest());
    }
  }, [
    categories.data.length,
    dispatch,
    products.data.length,
    products.topDiscountProducts.length,
    products.latestProducts.length,
  ]);

  const onAddCart = useCallback(
    (product) => {
      addCart(product);
    },
    [addCart]
  );

  return (
    <>
      <Suspense fallback={<Loading />}>
        <Tooltip toast={toast} />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Header />
      </Suspense>
      <section className="product spad">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-5">
              <div className="sidebar">
                <Suspense fallback={<Loading />}>
                  <LatestProducts products={products} />
                </Suspense>
                <Suspense fallback={<Loading />}>
                  <PriceRangeSlider
                    minValue={minValue}
                    setMinValue={setMinValue}
                    maxValue={maxValue}
                    setMaxValue={setMaxValue}
                  />
                </Suspense>
                <Suspense fallback={<Loading />}>
                  <ListCategories categories={categories} />
                </Suspense>
              </div>
            </div>
            <div className="col-lg-9 col-md-7">
              <Suspense fallback={<Loading />}>
                <Discount products={products} onAddCart={onAddCart} />
              </Suspense>
              <Suspense fallback={<Loading />}>
                <ListProducts
                  products={products}
                  onAddCart={onAddCart}
                  minValue={minValue}
                  maxValue={maxValue}
                />
              </Suspense>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- Product Section End --> */}
    </>
  );
};

export default memo(Products);
